export const createCellStateKey = (col, code) => {
    return col + "_" + code;
};
export const convertToDomId = (colLabel) => {
    return colLabel.replace(/\s/g, "_");
};
export const createCellId = (col, row) => {
    return col + "_" + row;
};
export const getKey = (jobPanel) => {
    const type = jobPanel.key.type;
    if (type == "keyDate") {
        const keyDate = jobPanel.key.keyDate;
        return keyDate;
    }
    else if (type == "global") {
        return "";
    }
    else {
        return null;
    }
};
export const translateCellStateMessage = (t, message) => {
    let messageParts = message.split("|");
    let key = messageParts.shift();
    let params = Object.assign(messageParts);
    return t("translations:cell state " + key, params);
};
